import * as React from 'react';

export function useOnlineStatus(): boolean {
  const [online, setOnline] = React.useState<boolean>(() =>
    typeof navigator === 'undefined' ? true : navigator.onLine,
  );
  React.useEffect(() => {
    function up() {
      setOnline(true);
    }
    function down() {
      setOnline(false);
    }
    window.addEventListener('online', up);
    window.addEventListener('offline', down);
    return () => {
      window.removeEventListener('online', up);
      window.removeEventListener('offline', down);
    };
  }, []);
  return online;
}

type StandaloneMode = 'standalone' | 'browser';

export function useDisplayMode(): StandaloneMode {
  const [mode, setMode] = React.useState<StandaloneMode>(() => detect());
  React.useEffect(() => {
    if (typeof window === 'undefined') return;
    const mql = window.matchMedia('(display-mode: standalone)');
    const cb = () => setMode(detect());
    mql.addEventListener?.('change', cb);
    return () => mql.removeEventListener?.('change', cb);
  }, []);
  return mode;
}

function detect(): StandaloneMode {
  if (typeof window === 'undefined') return 'browser';
  if (window.matchMedia('(display-mode: standalone)').matches) return 'standalone';
  // iOS Safari quirk
  if ('standalone' in window.navigator && (window.navigator as { standalone?: boolean }).standalone) {
    return 'standalone';
  }
  return 'browser';
}
